var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/email.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/footer/email.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
output += "<div class=\"c-quick-links__inner dom-footer-email-signup\">\n\n    <a ";
output += runtime.suppressValue((lineno = 4, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer","email","signup"])), env.opts.autoescape);
output += " href=\"#\" class=\"c-quick-links__a js-footer-email-signup\" rel=\"nofollow\">\n\n        <svg class=\"c-quick-links__email-icon\" aria-labelledby=\"a-get-email-title\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 95.5 95.5\" style=\"enable-background:new 0 0 95.5 95.5;\" xml:space=\"preserve\">\n            <title id=\"a-get-email-title\">";
output += runtime.suppressValue((lineno = 7, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["core_footer-email-sign-up-section-label"])), env.opts.autoescape);
output += "</title>\n            <path d=\"M47.8,95.5C21.4,95.5,0,74.1,0,47.8C0,21.4,21.4,0,47.8,0s47.8,21.4,47.8,47.8C95.5,74.1,74.1,95.5,47.8,95.5z M47.8,3.5\n            C23.4,3.5,3.5,23.4,3.5,47.8S23.4,92,47.8,92S92,72.1,92,47.8S72.1,3.5,47.8,3.5z\"></path>\n            <rect x=\"39.5\" y=\"24\" width=\"3\" height=\"8.5\"></rect>\n            <rect x=\"54.6\" y=\"24\" width=\"3\" height=\"8.5\"></rect>\n            <rect x=\"47.1\" y=\"16.1\" width=\"3\" height=\"16.4\"></rect>\n            <path d=\"M47.8,59.1c-0.3,0-0.5-0.1-0.7-0.2L18.9,42.4c-0.6-0.3-0.8-1-0.6-1.6c0.2-0.6,0.7-1,1.4-1h56.3c0.6,0,1.2,0.4,1.4,1\n                c0.2,0.6-0.1,1.3-0.6,1.6L48.5,58.9C48.3,59,48,59.1,47.8,59.1z M24.8,42.6l22.9,13.4l22.9-13.4H24.8z\"/>\n            <path d=\"M75.9,70.4H19.6c-0.8,0-1.4-0.6-1.4-1.4V41.2c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v26.4h53.5V41.2c0-0.8,0.6-1.4,1.4-1.4\n                c0.8,0,1.4,0.6,1.4,1.4V69C77.3,69.8,76.7,70.4,75.9,70.4z\"/>\n            <rect x=\"28.7\" y=\"48.4\" transform=\"matrix(0.6281 0.7782 -0.7782 0.6281 58.0532 -1.1069)\" width=\"3\" height=\"23.6\"></rect>\n            <rect x=\"53.7\" y=\"59\" transform=\"matrix(0.7783 0.6279 -0.6279 0.7783 52.4889 -27.7211)\" width=\"23.6\" height=\"3\"></rect>\n        </svg>\n\n        <div class=\"c-quick-links__title\" data-qa-footer-email-signup>\n            ";
output += runtime.suppressValue((lineno = 22, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["core_footer-email-sign-up-section-label"])), env.opts.autoescape);
output += "\n        </div>\n\n    </a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/email.j2"] , dependencies)